export const TYPES = {
  GET_STAFF_ACTIVE_SUCCESS: "staff/GET_STAFF_ACTIVE_SUCCESS",
  GET_STAFFS_SUCCESS: "staff/GET_STAFFS_SUCCESS",
  GET_SEARCH_SUCCESS: "staff/GET_SEARCH_SUCCESS",
  GET_STAFFS_INFO_SUCCESS: "staff/GET_STAFFS_INFO_SUCCESS",
  SELECT_DETAIL_STAFF_SUCCESS: "staff/SELECT_DETAIL_STAFF_SUCCESS",
  SELECT_DETAIL_INFO_STAFF_SUCCESS: "staff/SELECT_DETAIL_INFO_SUCCESS",

  GET_STAFF_SUCCESS: "staff/GET_STAFF_SUCCESS",

  SNAP_ALL_STAFF_SUCCESS : "staff/SNAP_ALL_STAFF_SUCCESS",
};
